"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactDnd = require("react-dnd");
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var target = {
  hover: function hover(props, monitor, component) {
    var lastElementId = props.lastElementId,
      hoverElement = props.hoverElement;
    var hoverBoundingRect = _reactDom["default"].findDOMNode(component).getBoundingClientRect();
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var clientOffset = monitor.getClientOffset();
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
    var hoveredElement;
    if (hoverClientY < hoverMiddleY) {
      // Top
      hoveredElement = {
        id: lastElementId,
        top: false,
        middle: false,
        bottom: true
      };
    } else {
      // Bottom
      hoveredElement = {
        id: 0,
        top: false,
        middle: false,
        bottom: false
      };
    }
    var prevHoveredElement = (0, _pick2["default"])(props.hoveredElement, ['id', 'top', 'middle', 'bottom']);
    if (!(0, _isEqual2["default"])(prevHoveredElement, hoveredElement)) {
      hoverElement(hoveredElement);
    }
  }
};
function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}
var Element = /*#__PURE__*/function (_React$Component) {
  function Element() {
    _classCallCheck(this, Element);
    return _callSuper(this, Element, arguments);
  }
  _inherits(Element, _React$Component);
  return _createClass(Element, [{
    key: "render",
    value: function render() {
      var connectDropTarget = this.props.connectDropTarget;
      return connectDropTarget(/*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lastElement
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Element, "propTypes", {
  connectDropTarget: _propTypes["default"].func.isRequired,
  dragDropType: _propTypes["default"].string,
  lastElementId: _propTypes["default"].number,
  hoverElement: _propTypes["default"].func,
  hoveredElement: _propTypes["default"].object
});
var _default = exports["default"] = (0, _reactDnd.DropTarget)(function (props) {
  return props.dragDropType;
}, target, collectTarget)(Element);